import * as React from "react";

function SvgSporadicDemand(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 12h2l2-7 2 7h3l2-7 2 7h1" stroke="#B87614" /></svg>;
}

export default SvgSporadicDemand;